import React, {useEffect} from 'react';
import {NodeModel} from '@minoru/react-dnd-treeview';
import {Button, Icon, ListItem, Menu, MenuDivider, MenuItem, Text} from '@mc/ui-v4';
import {mcDelete, mcEdit} from '@mc/react-ui-icons';
import {CiselnikVO} from '../../../api';

type Props = {
    node: NodeModel<CiselnikVO>;
    onToggle: () => void;
    onEdit: (ciselnik: CiselnikVO) => void;
    onRemove: (ciselnik: CiselnikVO) => void;
};

/** Jeden uzel stromu hodnot číselníku s přesouváním mezi úrovněmi pomocí drag&drop (obdoba treeActions/CustomNode). */
export const CiselnikTreeNode: React.FC<Props> = ({node, onToggle, onEdit, onRemove}) => {
    const ciselnik = node.data;

    // Otevřít uzel, aby byli potomci vidět (stejně jako v ostatních stromech aplikace).
    useEffect(() => onToggle(), []);

    return (
        <ListItem
            className={'custom-node'}
            bodyClassName="w-100"
            extra={
                <Button
                    style={'link'}
                    menu={
                        <Menu>
                            <MenuItem
                                onClick={() => onEdit(ciselnik)}
                                text={
                                    <Text intent={'primary'} icon={<Icon icon={mcEdit} />}>
                                        Upravit hodnotu
                                    </Text>
                                }
                            />
                            <MenuDivider />
                            <MenuItem
                                onClick={() => onRemove(ciselnik)}
                                text={
                                    <Text intent={'danger'} icon={<Icon icon={mcDelete} />}>
                                        Smazat hodnotu
                                    </Text>
                                }
                            />
                        </Menu>
                    }
                />
            }
        >
            <Text strong>{ciselnik.nazev}</Text>
        </ListItem>
    );
};
